var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagesix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1502,
    height: 147,
    viewBox: "0 0 1502 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_15078)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1502,
    height: 147,
    rx: 16,
    fill: "url(#paint0_linear_106_15078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.872 85V59.8H643.512C645.504 59.8 647.148 60.136 648.444 60.808C649.74 61.456 650.7 62.344 651.324 63.472C651.948 64.6 652.26 65.872 652.26 67.288C652.26 68.656 651.948 69.904 651.324 71.032C650.724 72.16 649.776 73.072 648.48 73.768C647.184 74.44 645.528 74.776 643.512 74.776H638.472V85H634.872ZM638.472 71.788H643.368C645.216 71.788 646.536 71.38 647.328 70.564C648.144 69.748 648.552 68.656 648.552 67.288C648.552 65.848 648.144 64.744 647.328 63.976C646.536 63.184 645.216 62.788 643.368 62.788H638.472V71.788ZM654.766 85V67.144H657.934L658.258 70.924H658.366C658.894 69.748 659.458 68.86 660.058 68.26C660.658 67.66 661.354 67.252 662.146 67.036C662.938 66.82 663.874 66.712 664.954 66.712V70.492H663.982C663.118 70.492 662.326 70.612 661.606 70.852C660.91 71.068 660.322 71.404 659.842 71.86C659.362 72.292 658.99 72.868 658.726 73.588C658.486 74.308 658.366 75.16 658.366 76.144V85H654.766ZM667.505 85V67.144H671.105V85H667.505ZM669.305 63.904C668.633 63.904 668.069 63.688 667.613 63.256C667.157 62.8 666.929 62.236 666.929 61.564C666.929 60.94 667.145 60.412 667.577 59.98C668.033 59.524 668.609 59.296 669.305 59.296C669.977 59.296 670.541 59.524 670.997 59.98C671.453 60.412 671.681 60.952 671.681 61.6C671.681 62.248 671.453 62.8 670.997 63.256C670.541 63.688 669.977 63.904 669.305 63.904ZM679.949 85L673.613 67.144H677.393L682.289 82.156H682.397L687.329 67.144H691.037L684.701 85H679.949ZM698.781 85.432C697.341 85.432 696.141 85.192 695.181 84.712C694.245 84.208 693.537 83.536 693.057 82.696C692.601 81.856 692.373 80.944 692.373 79.96C692.373 78.784 692.673 77.776 693.273 76.936C693.897 76.096 694.785 75.448 695.937 74.992C697.113 74.536 698.517 74.308 700.149 74.308H704.865C704.865 73.228 704.697 72.34 704.361 71.644C704.049 70.948 703.581 70.432 702.957 70.096C702.333 69.736 701.577 69.556 700.689 69.556C699.585 69.556 698.625 69.832 697.809 70.384C697.017 70.912 696.537 71.74 696.369 72.868H692.769C692.913 71.548 693.345 70.444 694.065 69.556C694.785 68.644 695.721 67.948 696.873 67.468C698.025 66.964 699.297 66.712 700.689 66.712C702.393 66.712 703.821 67.012 704.973 67.612C706.125 68.212 706.989 69.064 707.565 70.168C708.165 71.248 708.465 72.532 708.465 74.02V85H705.441L705.081 82.012H704.973C704.661 82.564 704.289 83.056 703.857 83.488C703.449 83.896 702.981 84.244 702.453 84.532C701.925 84.82 701.349 85.036 700.725 85.18C700.125 85.348 699.477 85.432 698.781 85.432ZM699.609 82.516C700.425 82.516 701.145 82.36 701.769 82.048C702.417 81.736 702.957 81.316 703.389 80.788C703.845 80.236 704.181 79.624 704.397 78.952C704.637 78.28 704.769 77.584 704.793 76.864H700.509C699.453 76.864 698.601 76.984 697.953 77.224C697.329 77.464 696.873 77.8 696.585 78.232C696.297 78.664 696.153 79.168 696.153 79.744C696.153 80.296 696.285 80.788 696.549 81.22C696.837 81.628 697.233 81.952 697.737 82.192C698.265 82.408 698.889 82.516 699.609 82.516ZM720.181 85.432C718.333 85.432 716.725 85.036 715.357 84.244C713.989 83.452 712.933 82.36 712.189 80.968C711.445 79.552 711.073 77.92 711.073 76.072C711.073 74.224 711.457 72.604 712.225 71.212C713.017 69.796 714.097 68.692 715.465 67.9C716.857 67.108 718.429 66.712 720.181 66.712C722.365 66.712 724.189 67.288 725.653 68.44C727.141 69.568 728.089 71.092 728.497 73.012H724.753C724.513 71.932 723.961 71.104 723.097 70.528C722.257 69.928 721.273 69.628 720.145 69.628C719.185 69.628 718.297 69.88 717.481 70.384C716.665 70.864 716.005 71.584 715.501 72.544C714.997 73.48 714.745 74.656 714.745 76.072C714.745 77.104 714.877 78.016 715.141 78.808C715.429 79.576 715.813 80.236 716.293 80.788C716.797 81.316 717.373 81.724 718.021 82.012C718.669 82.276 719.377 82.408 720.145 82.408C720.913 82.408 721.609 82.276 722.233 82.012C722.881 81.748 723.421 81.376 723.853 80.896C724.309 80.392 724.609 79.804 724.753 79.132H728.497C728.089 81.028 727.141 82.552 725.653 83.704C724.189 84.856 722.365 85.432 720.181 85.432ZM733.718 92.38L738.002 82.984H736.922L729.722 67.144H733.61L739.334 80.14H739.442L745.058 67.144H748.838L737.534 92.38H733.718ZM758.727 85V59.8H767.367C769.359 59.8 771.003 60.136 772.299 60.808C773.595 61.456 774.555 62.344 775.179 63.472C775.803 64.6 776.115 65.872 776.115 67.288C776.115 68.656 775.803 69.904 775.179 71.032C774.579 72.16 773.631 73.072 772.335 73.768C771.039 74.44 769.383 74.776 767.367 74.776H762.327V85H758.727ZM762.327 71.788H767.223C769.071 71.788 770.391 71.38 771.183 70.564C771.999 69.748 772.407 68.656 772.407 67.288C772.407 65.848 771.999 64.744 771.183 63.976C770.391 63.184 769.071 62.788 767.223 62.788H762.327V71.788ZM785.99 85.432C784.31 85.432 782.786 85.048 781.418 84.28C780.074 83.488 779.006 82.396 778.214 81.004C777.422 79.588 777.026 77.944 777.026 76.072C777.026 74.2 777.422 72.568 778.214 71.176C779.006 69.76 780.086 68.668 781.454 67.9C782.822 67.108 784.358 66.712 786.062 66.712C787.742 66.712 789.266 67.108 790.634 67.9C792.002 68.668 793.07 69.76 793.838 71.176C794.63 72.568 795.026 74.2 795.026 76.072C795.026 77.944 794.63 79.588 793.838 81.004C793.046 82.396 791.966 83.488 790.598 84.28C789.23 85.048 787.694 85.432 785.99 85.432ZM785.99 82.48C786.95 82.48 787.826 82.252 788.618 81.796C789.434 81.316 790.094 80.608 790.598 79.672C791.102 78.712 791.354 77.512 791.354 76.072C791.354 74.632 791.102 73.444 790.598 72.508C790.118 71.548 789.47 70.84 788.654 70.384C787.862 69.904 786.998 69.664 786.062 69.664C785.126 69.664 784.25 69.904 783.434 70.384C782.618 70.84 781.958 71.548 781.454 72.508C780.95 73.444 780.698 74.632 780.698 76.072C780.698 77.512 780.95 78.712 781.454 79.672C781.958 80.608 782.606 81.316 783.398 81.796C784.214 82.252 785.078 82.48 785.99 82.48ZM797.961 85V59.62H801.561V85H797.961ZM805.563 85V67.144H809.163V85H805.563ZM807.363 63.904C806.691 63.904 806.127 63.688 805.671 63.256C805.215 62.8 804.987 62.236 804.987 61.564C804.987 60.94 805.203 60.412 805.635 59.98C806.091 59.524 806.667 59.296 807.363 59.296C808.035 59.296 808.599 59.524 809.055 59.98C809.511 60.412 809.739 60.952 809.739 61.6C809.739 62.248 809.511 62.8 809.055 63.256C808.599 63.688 808.035 63.904 807.363 63.904ZM821.572 85.432C819.724 85.432 818.116 85.036 816.748 84.244C815.38 83.452 814.324 82.36 813.58 80.968C812.836 79.552 812.464 77.92 812.464 76.072C812.464 74.224 812.848 72.604 813.616 71.212C814.408 69.796 815.488 68.692 816.856 67.9C818.248 67.108 819.82 66.712 821.572 66.712C823.756 66.712 825.58 67.288 827.044 68.44C828.532 69.568 829.48 71.092 829.888 73.012H826.144C825.904 71.932 825.352 71.104 824.488 70.528C823.648 69.928 822.664 69.628 821.536 69.628C820.576 69.628 819.688 69.88 818.872 70.384C818.056 70.864 817.396 71.584 816.892 72.544C816.388 73.48 816.136 74.656 816.136 76.072C816.136 77.104 816.268 78.016 816.532 78.808C816.82 79.576 817.204 80.236 817.684 80.788C818.188 81.316 818.764 81.724 819.412 82.012C820.06 82.276 820.768 82.408 821.536 82.408C822.304 82.408 823 82.276 823.624 82.012C824.272 81.748 824.812 81.376 825.244 80.896C825.7 80.392 826 79.804 826.144 79.132H829.888C829.48 81.028 828.532 82.552 827.044 83.704C825.58 84.856 823.756 85.432 821.572 85.432ZM835.109 92.38L839.393 82.984H838.313L831.113 67.144H835.001L840.725 80.14H840.833L846.449 67.144H850.229L838.925 92.38H835.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_15078)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_106_15078)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1356,
    y: 73,
    width: 148,
    height: 148,
    rx: 74,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_106_15078)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1467,
    cy: 162.724,
    rx: 62.9,
    ry: 58.275,
    fill: "#636980"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_106_15078)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1406.87,
    cy: 170.124,
    rx: 63.825,
    ry: 65.675,
    fill: "#50965B"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.78,
    filter: "url(#filter3_f_106_15078)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1430.93,
    cy: 126.65,
    rx: 80.475,
    ry: 74,
    fill: "#2C963D"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_106_15078)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_106_15078)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -18,
    width: 91,
    height: 91,
    rx: 45.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_106_15078)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2502,
    cy: 37.1691,
    rx: 38.675,
    ry: 35.8312,
    fill: "#636980"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_106_15078)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.2809,
    cy: 41.7191,
    rx: 39.2437,
    ry: 40.3812,
    fill: "#50965B"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.78,
    filter: "url(#filter7_f_106_15078)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.0691,
    cy: 14.9883,
    rx: 49.4812,
    ry: 45.5,
    fill: "#2C963D"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_15078",
    x: 1195.55,
    y: -80.0455,
    width: 468.891,
    height: 468.891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 41.7091,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_106_15078"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 59.3682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.382766 0 0 0 0 0.663462 0 0 0 0 0.427783 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_15078"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_15078",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_106_15078",
    x: 1350.45,
    y: 50.7992,
    width: 233.1,
    height: 223.851,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.825,
    result: "effect1_foregroundBlur_106_15078"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_106_15078",
    x: 1289.4,
    y: 50.7992,
    width: 234.95,
    height: 238.65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.825,
    result: "effect1_foregroundBlur_106_15078"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_106_15078",
    x: 1293.44,
    y: -4.36325,
    width: 274.977,
    height: 262.027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.5068,
    result: "effect1_foregroundBlur_106_15078"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_106_15078",
    x: -108.652,
    y: -112.102,
    width: 288.305,
    height: 288.305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 25.6455,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_106_15078"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.55
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.5034
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.384314 0 0 0 0 0.662745 0 0 0 0 0.427451 0 0 0 0.83 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_15078"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_15078",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_106_15078",
    x: -13.4123,
    y: -31.6496,
    width: 143.325,
    height: 137.637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.4937,
    result: "effect1_foregroundBlur_106_15078"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_106_15078",
    x: -50.9504,
    y: -31.6496,
    width: 144.462,
    height: 146.737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.4937,
    result: "effect1_foregroundBlur_106_15078"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_106_15078",
    x: -48.4678,
    y: -65.5674,
    width: 169.074,
    height: 161.111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5278,
    result: "effect1_foregroundBlur_106_15078"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_15078",
    x1: 0,
    y1: 73.5,
    x2: 1502,
    y2: 73.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C963D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F5613"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_15078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1502,
    height: 147,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_106_15078"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1356,
    y: 73,
    width: 148,
    height: 148,
    rx: 74,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_106_15078"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -18,
    width: 91,
    height: 91,
    rx: 45.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesix);
export default __webpack_public_path__ + "static/media/imagesix.1cbc6a522e8ffc3956c00c3b834c17a3.svg";
export { ForwardRef as ReactComponent };